import GeneratedDocumentStore from "./generated/GeneratedDocumentStore"

class DocumentStore extends GeneratedDocumentStore {

}

export const documentStore = new DocumentStore()
